import { _retrieveCardPaymentAcceptResult } from '~/services/actions/CSU/retrieve-card-payment-accept-result';
import { getRetrieveCardPaymentSettings } from '~/utils/payment/submit-order-settings';
import {
  IEventResult,
  PaymentConnectorPostMessageType,
} from '~/interfaces/payment';
import payNow from '~/utils/checkout/pay-now';
import { ISalesOrderResponse } from '~/interfaces/get-sales-order';
import { wmapStore } from '~/store/wmap-store';
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import { paymentErrorRedirect } from '~/utils/payment/payment-error-redirect';
import { Maybe, UsAePayErrorMessage } from '~/gql/__generated__/types';
import { TYPES } from '~/modules/payment/constants';

export function submitPayment(
  isForterValidationEnabled: boolean,
  event: MessageEvent,
  cartId: string,
  orderDetails: ISalesOrderResponse,
  router: AppRouterInstance,
  setSyfOverlay: (useSyfOverlay: boolean) => void,
  affirmPromoValue?: string,
  usaEPayErrorMessages?: Maybe<Maybe<UsAePayErrorMessage>[]> | undefined,
  isForterValidationEnabledForAdyen?: boolean,
  onHeightChange?: (height: number) => void,
) {
  if (typeof event.data !== 'string') return;

  let result: IEventResult;
  try {
    result = JSON.parse(event.data) as IEventResult;
  } catch (error) {
    console.error('Failed to parse event data:', error);
    return;
  }

  const { value: authCode, id: connectorId, type } = result;
  const setCreditCardValid = wmapStore.getState().setCreditCardValid;

  if (result?.type === PaymentConnectorPostMessageType.Height) {
    wmapStore.getState().setIsLoading(false);
    const height = Number(result.value);
    if (onHeightChange && Number.isFinite(height) && height > 0) {
      onHeightChange(height);
    }
  } else if (
    result?.type === PaymentConnectorPostMessageType.IS_CREDIT_CARD_VALID
  ) {
    // USAePay validation message
    const decodedValue = JSON.parse(atob(result?.value)) as {
      USAePAyValid: boolean;
    };
    setCreditCardValid(decodedValue?.USAePAyValid);
  } else if (
    result?.type === PaymentConnectorPostMessageType.ADYEN_VALIDATION
  ) {
    // Adyen validation message - sent on every field change
    setCreditCardValid(!!result?.value);
  }
  if (
    ![
      String(PaymentConnectorPostMessageType.Result),
      String(PaymentConnectorPostMessageType.SynchronyClose),
    ].includes(type)
  ) {
    return;
  } else {
    setSyfOverlay(true);
  }

  _retrieveCardPaymentAcceptResult(
    getRetrieveCardPaymentSettings(connectorId, cartId, authCode),
  )
    .then(async (response) => {
      const tokenizedCard = response?.TokenizedPaymentCard;
      if (response?.errCode) {
        const paymentOption = wmapStore.getState().selectedPaymentOption;

        const errorCode =
          paymentOption === TYPES.ADYEN ? response?.Code : response.errCode;
        paymentErrorRedirect(
          errorCode || response.errCode,
          orderDetails.QuotationId || orderDetails.SalesId,
          router,
          usaEPayErrorMessages,
        );
      }
      try {
        if (tokenizedCard) {
          await payNow({
            tokenizedCard,
            isForterValidationEnabled,
            cartId,
            orderDetails,
            router,
            affirmPromoValue,
            isForterValidationEnabledForAdyen,
          });
          setSyfOverlay(false);
        }
      } catch (placeOrderError) {
        console.error('Error placing order:', placeOrderError);
        setSyfOverlay(false);
      }
    })
    .catch((retrievePaymentResultError) => {
      setSyfOverlay(false);
      console.error(
        'Error retrieving payment result:',
        retrievePaymentResultError,
      );
    });
}
